import { render } from "./PressKitPage.vue?vue&type=template&id=190e112e&scoped=true"
import script from "./PressKitPage.vue?vue&type=script&lang=js"
export * from "./PressKitPage.vue?vue&type=script&lang=js"

import "./PressKitPage.vue?vue&type=style&index=0&id=190e112e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-190e112e"]])

export default __exports__